import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'kangarootime-ui';
import MemberCount from './MemberCount';
import ChannelDetailsButton from './ChannelDetailsButton';
import './ChannelHeader.css';

const ChannelHeader = ({
  name,
  topic,
  channelMemberCount,
  toggleChannelInformationModal,
  isDirectMessage,
  toggleChannelMembersDialog,
  ...props
}) => {
  // only show the members icon in the header if the channel is public or private OR it's a direct message with more than two members
  const showMembersIcon = !isDirectMessage || (isDirectMessage && channelMemberCount > 2);

  return (
    <section className='channel-header-container'>
      <Typography type='bold' style={{ fontSize: 14 }}>{name}</Typography>
      <div className='flex-rows'>
        { topic && <Typography style={{ fontSize: 10, lineHeight: 1, marginRight: 4 }}>{topic}</Typography> }
        { showMembersIcon && <MemberCount count={channelMemberCount} onClick={toggleChannelMembersDialog} /> }
        { !isDirectMessage && <ChannelDetailsButton onClick={toggleChannelInformationModal} /> }
      </div>
    </section>
  );
};

ChannelHeader.propTypes = {
  name: PropTypes.string,
  topic: PropTypes.string,
  channelMemberCount: PropTypes.number,
  toggleChannelInformationModal: PropTypes.func,
  isDirectMessage: PropTypes.bool,
  toggleChannelMembersDialog: PropTypes.func
};

ChannelHeader.defaultProps = {
  channelMemberCount: 0
};

export default ChannelHeader;
